
const file = {
	state: {
		// 其他附件信息
		file_info:[]
	},

	mutations: {
		SET_FILEINFO:(state,data) => {
			state.file_info = data.file_info
		}
	},

	actions: {
		// 设置文件默认信息
		setFileInfo({commit}, data) {
			commit('SET_FILEINFO', data)
		}
	}
}

export default file
